import { ReactNode } from "react";

import { decode } from "he";

import { Anchor } from "@atlassiansox/bxp-content-framework";

import { RightArrow, Play } from "../icons";

import {
    BxpButton,
    BxpLink,
    getAppearance,
    getSpacing,
    getProminence
} from "./link-button.styles";

import type { LinkButtonThemeModelContent } from "../../mocks";

export type LinkButtonProps = {
    readonly children: ReactNode;
    readonly id?: string;
    readonly className?: string;
    readonly onClick?: () => void;
    readonly url?: string;
    readonly testId?: string;
    readonly tabIndex?: number;
} & {
    readonly "aria-label"?: string;
    readonly "aria-labelledby"?: string;
} & LinkButtonThemeModelContent;

export const LinkButton = ({
    appearance,
    style,
    children,
    decorator,
    id,
    className,
    isBlock,
    prominence,
    onClick,
    spacing,
    url,
    testId,
    tabIndex,
    ...rest
}: LinkButtonProps) => {
    // Decode HTML entities if children is a string
    const decodedChildren =
        typeof children === "string" ? decode(children) : children;

    const buttonText = (
        <>
            <span>{decodedChildren}</span>
            {decorator === "Arrow" && <RightArrow />}
            {decorator === "Play" && <Play />}
        </>
    );

    const appearanceCss = getAppearance(appearance, style);
    const prominenceCss = getProminence(prominence, style);
    const spacingCss = getSpacing(spacing);

    const elementProps = {
        id,
        onClick,
        tabIndex,
        ...rest
    };
    return onClick && !url ? (
        <BxpButton
            $bxpIsBlock={false}
            $bxpAppearance={appearanceCss}
            $bxpProminence={prominenceCss}
            $bxpSpacing={spacingCss}
            className={className}
        >
            <button {...elementProps} data-testid={testId} type="button">
                {buttonText}
            </button>
        </BxpButton>
    ) : (
        <BxpLink
            $bxpIsBlock={false}
            $bxpAppearance={appearanceCss}
            $bxpProminence={prominenceCss}
            $bxpSpacing={spacingCss}
            className={className}
        >
            <Anchor {...elementProps} href={url} testId={testId}>
                {buttonText}
            </Anchor>
        </BxpLink>
    );
};
